import { ModelEditor } from '@felicity/data-management';
import Profile from '../models/Profile.mjs';
import RoleSelector from './RoleSelector.mjs';
import './ProfileEditor.scss';

/**
 * Model editor for identity profiles
 */
export default class ProfileEditor extends ModelEditor {
  constructor() {
    super(Profile);
  }

  template() {
    const dict = window.i18n?.dictionary;

    return `
      ${this.editorTemplateFor(dict.phrase('firstName', 'profile', 'model'), 'firstName', this.metadata)}
      ${this.editorTemplateFor(dict.phrase('lastName', 'profile', 'model'), 'lastName', this.metadata)}
      ${this.editorTemplateFor(dict.phrase('organisationName', 'profile', 'model'), 'organisationName', this.metadata)}
      ${this.editorTemplateFor(dict.phrase('phoneNumber', 'profile', 'model'), 'phoneNumber', this.metadata)}
      ${this.editorTemplateFor(dict.phrase('phoneNumberConfirmed', 'profile', 'model'), 'phoneNumberConfirmed', this.metadata)}
      ${this.editorTemplateFor(dict.phrase('email', 'profile', 'model'), 'email', this.metadata)}
      ${this.editorTemplateFor(dict.phrase('emailConfirmed', 'profile', 'model'), 'emailConfirmed', this.metadata)}
      ${this.editorTemplateFor(dict.phrase('roles', 'profile', 'model'), 'roles', this.metadata)}`;
  }

  // edit(mode, data, form, dialog) {
  //   super.edit(mode, data, form, dialog);

  //   this.viewModel.on('value_set', (e) => {
  //     if (e.detail.property === 'email') {
  //       this.viewModel.emailConfirmed = false;
  //     }
  //   });
  // }

  _initEditors(form) {
    super._initEditors(form);

    const roleSelector = RoleSelector.replace(form.querySelector('[name="roles"]'), true);
    roleSelector.classList.add('e-float-input');
    roleSelector.closest('.e-control-wrapper').classList = 'editor-group';
  }
}
